module.exports = __webpack_public_path__ + "img/avex_coaches_top@3x.7aac6d10.jpg";